export default {
  PENDING: 0,
  LINK_OPENED: 1,
  OFFER_SENT: 2,
  ACCEPTED: 3,
  CONFIRMED: 4,
  REJECTED: 5,
}
